<template>
  <div class="home" @click="hideTimeBlock" :class="['home', { 'time-active': isTimeBlock }]">
    <BackButton @click="goBack" />
    <div class="balanceBlock">
      <div class="cashBlock">
        <p style="display: flex; gap: 5px; position: relative">
          {{ $t("your-balance") }}
          <span style="color: var(--text-color3); font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 3px" @click="openCurrencies"
            >{{ currency.name }}
            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 1.5L6 6L10.5 1.5" stroke="var(--text-color3)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <Transition name="fade">
            <span class="selectCurrencies" v-if="isSelectCurrency">
              <p @click="selectCurrency('RUB')">RUB</p>
              <p @click="selectCurrency('UAH')">UAH</p>
              <p @click="selectCurrency('USD')">USD</p>
              <p @click="selectCurrency('KZT')">KZT</p>
            </span>
          </Transition>
        </p>
        <p class="cashText" v-if="isBalanceLoading">
          <BalanceSkeleton size="md" separator="," :symbol="currency.symbol" show-symbol />
        </p>
        <p class="cashText" v-else>
          {{ balance }},<span>{{ balanceCents }} {{ currency.symbol }}</span>
        </p>
      </div>
      <button class="depositButton" @click="$router.push('/finance/deposit')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.041626 9.00002C0.041626 4.05247 4.05241 0.041687 8.99996 0.041687C13.9475 0.041687 17.9583 4.05247 17.9583 9.00002C17.9583 13.9476 13.9475 17.9584 8.99996 17.9584C4.05241 17.9584 0.041626 13.9476 0.041626 9.00002ZM9.74996 5.66669C9.74996 5.25247 9.41417 4.91669 8.99996 4.91669C8.58574 4.91669 8.24996 5.25247 8.24996 5.66669V8.25002H5.66663C5.25241 8.25002 4.91663 8.58581 4.91663 9.00002C4.91663 9.41423 5.25241 9.75002 5.66663 9.75002H8.24996V12.3334C8.24996 12.7476 8.58574 13.0834 8.99996 13.0834C9.41417 13.0834 9.74996 12.7476 9.74996 12.3334V9.75002H12.3333C12.7475 9.75002 13.0833 9.41423 13.0833 9.00002C13.0833 8.58581 12.7475 8.25002 12.3333 8.25002H9.74996V5.66669Z"
            fill="white"
          />
        </svg>
        {{ $t("deposit") }}
      </button>
    </div>
    <div class="pairBlock" @click="openPairs">
      <div class="images">
        <img v-if="!isTradeShare" src="../assets/icons/testUSDT.svg" id="secondImage" />
        <img :src="activeSymbol.img || ''" id="firstImage" v-if="!isLoadingActives && activeSymbol.img" />
      </div>
      <p v-if="!isLoadingActives && activeSymbol && activeSymbol.symbol">
        {{ activeSymbol.symbol }} / {{ isTradeShare ? currency.name : 'USDT' }}
      </p>
      <p v-else style="opacity: 0.5;">{{ $t('loading') }}</p>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin: auto; margin-right: 10px">
        <path d="M4.5 7.5L9 12L13.5 7.5" stroke="var(--text-color1)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <Transition name="fade">
        <div class="selectPairBlock" v-if="isShowSelectPair">
          <div class="activesList" v-if="actives">
            <div class="activeBlock" v-for="i in actives" :key="i" @click="selectPair(i)">
              <img :src="i.img" width="25" />
              <p>{{ i.name }}</p>
            </div>
          </div>
        </div>
      </Transition>
    </div>
    <div class="tradingBlock">
      <div class="timeClick">
        <p :class="currentTimeFrame == '1m' ? 'selectedTime' : null" @click="selectTime('1m', $event)">1m</p>
        <p :class="currentTimeFrame == '30m' ? 'selectedTime' : null" @click="selectTime('30m', $event)">30m</p>
        <p :class="currentTimeFrame == '1h' ? 'selectedTime' : null" @click="selectTime('1h', $event)">1h</p>
      </div>
      <div class="chartBlock">
        <div ref="chartContainer" style="width: 100%; height: 100%; border-radius: 10px; overflow: hidden"></div>
      </div>
      <div class="controlBlock" v-if="!isNotifyShow && !isErrorShow && !isResultShow">
        <div class="inputBlock">
          <div class="inputText">
            <p style="margin-right: 5px" @click="betAmount / 2 <= 0 ? null : (betAmount = Math.floor(betAmount / 2))">1/2</p>
            <hr class="verticalHr" />
          </div>
          <input type="number" :placeholder="100 + currency.symbol" v-model="betAmount" />
          <div class="inputText">
            <hr class="verticalHr" />
            <p style="margin-left: 5px" @click="betAmount *= 2">x2</p>
          </div>
        </div>
        <div class="buttonsBlock">
          <button class="downButton" @click="betStart('down')">
            <p>{{ $t("down") }}</p>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.83337 3.33337L17.1667 16.6667M17.1667 16.6667V7.50004M17.1667 16.6667H8.00004" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>

          <button class="timeButton" @click="openTime">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 8.66663V13L16.25 15.1666M13 23.8333C7.01688 23.8333 2.16663 18.983 2.16663 13C2.16663 7.01688 7.01688 2.16663 13 2.16663C18.983 2.16663 23.8333 7.01688 23.8333 13C23.8333 18.983 18.983 23.8333 13 23.8333Z" stroke="#2A2F35" stroke-opacity="0.5" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>

          <button class="upButton" @click="betStart('up')">
            <p>{{ $t("up") }}</p>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.33337 16.6667L16.6667 3.33337M16.6667 3.33337V12.5M16.6667 3.33337H7.50004" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
  <Transition name="slide-up">
    <div class="timeBlock" v-if="isTimeBlock">
      <div class="timeHeader">
        <div style="display: flex; gap: 10px; align-items: center">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 7.3335V11.0002L13.75 12.8335M11 20.1668C5.93743 20.1668 1.83337 16.0628 1.83337 11.0002C1.83337 5.93755 5.93743 1.8335 11 1.8335C16.0626 1.8335 20.1667 5.93755 20.1667 11.0002C20.1667 16.0628 16.0626 20.1668 11 20.1668Z" stroke="var(--black-to-white)" stroke-opacity="0.3" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <p>{{ $t("timerHead") }}</p>
        </div>
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" @click="hideTimeBlock" style="cursor: pointer">
          <rect width="30" height="30" rx="15" fill="var(--second-color)" />
          <rect x="19.9497" y="8.63623" width="2" height="16" rx="1" transform="rotate(45 19.9497 8.63623)" fill="#9E9EA1" />
          <rect x="21.364" y="19.9502" width="2" height="16" rx="1" transform="rotate(135 21.364 19.9502)" fill="#9E9EA1" />
        </svg>
      </div>
      <div class="timeSelectButtons">
        <div class="timeSelectButton" :class="selectedTime == '10' ? 'active' : ''" id="10sec" @click="selectTimeButton">
          <p>10 {{ $t("timerSec") }}</p>
        </div>
        <div class="timeSelectButton" :class="selectedTime == '30' ? 'active' : ''" id="30sec" @click="selectTimeButton">
          <p>30 {{ $t("timerSec") }}</p>
        </div>
        <div class="timeSelectButton" :class="selectedTime == '60' ? 'active' : ''" id="60sec" @click="selectTimeButton">
          <p>60 {{ $t("timerSec") }}</p>
        </div>
      </div>
      <input type="number" :placeholder="$t('timerSecAmount')" class="timeInput" v-model="selectedTime" @click="test" />
      <button class="timeAcceptButton" :class="selectedTime != '' ? 'active' : ''" @click="hideTimeBlock">{{ $t("done") }}</button>
    </div>
  </Transition>
  <TransitionGroup name="fade">
    <NotifyComponent :duration="selectedTime" :isBet="true" :notify="$t('betStarted')" :timely="true" v-if="isNotifyShow" @closeNotify="isNotifyShow = false" />
    <NotifyComponent :duration="3" :result="resultStatus" :resultAmount="resultBet.amount" :resultSymbol="currency.symbol" :notify="resultMessage" :timely="true" v-if="isResultShow" @closeNotify="isResultShow = false" />
    <NotifyComponent :duration="2" :notify="errorMessage" :timely="false" v-if="isErrorShow" @closeNotify="isErrorShow = false" />
  </TransitionGroup>
</template>

<script>
import NotifyComponent from "@/components/NotifyComponent.vue";
import BalanceSkeleton from "@/components/BalanceSkeleton.vue";
import axios from "axios";
import { createChart, BaselineSeries } from "lightweight-charts";
import { BackButton } from "vue-tg";
import { UserManager } from "@/utils/userManager";
import { translateApiError } from "@/utils/apiErrors";
import { applyBalanceResponse } from "@/utils/balanceHelpers";

export default {
  name: "TradingPage",
  components: {
    NotifyComponent,
    BalanceSkeleton,
    BackButton,
  },
  data() {
    return {
      currency: {
        name: this.$store.getters.getCurrency,
        symbol: "₽",
      },
      selectedTime: "10",
      isTimeBlock: false,
      theme: this.$store.getters.getTheme,
      isNotifyShow: false,

      graphData: [],
      timeFilterGraphData: [],

      baselineSeries: null,
      activeSymbol: null,
      actives: [],
      currentTimeFrame: "1h",
      betAmount: "",
      balance: 0,
      balanceCents: "00",
      balanceCurrencies: null,
      isBalanceLoading: true,
      isErrorShow: false,
      errorMessage: "",
      chart: null,
      isSelectCurrency: false,

      isResultShow: false,
      resultMessage: "",
      resultStatus: "",

      lineSeries: null,
      betLine: null,
      lastPoint: null,
      isShowSelectPair: false,

      socket: null,
      user: null,
      botId: null,

      resultBet: null,

      userTimezone: 0,
      isTradeShare: false,
      isLoadingActives: true,
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
    test() {
      console.log(new Date(1751206148 * 1000).toLocaleTimeString([], { timeZone: this.userTimezone }));
    },
    openTime() {
      console.log(this.$store);
      let home = document.querySelector(".home");
      home.style.opacity = "0.99";
      home.style.pointerEvents = "fill";
      document.body.style.overflow = "hidden";
      this.isTimeBlock = true;
    },
    hideTimeBlock(event) {
      if (!event.target.closest(".timeButton")) {
        let home = document.querySelector(".home");
        home.style.opacity = "1";
        home.style.pointerEvents = "all";
        this.isTimeBlock = false;
      }
      if (!event.target.closest(".selectCurrencies") && !event.target.closest("span") && this.isSelectCurrency) {
        this.isSelectCurrency = false;
      }
      if (!event.target.closest(".selectPairBlock") && !event.target.closest(".pairBlock") && !event.target.closest(".activeBlock") && this.isShowSelectPair) {
        this.isShowSelectPair = false;
      }
    },
    openPairs() {
      this.isShowSelectPair ? (this.isShowSelectPair = false) : (this.isShowSelectPair = true);
    },
    selectPair(pair) {
      console.log(pair);

      // 1. Очистка WebSocket
      if (this.socket) {
        this.socket.close();
        this.socket = null;
      }

      // 2. Удаление графика и всех связанных объектов
      if (this.chart) {
        if (this.baselineSeries) {
          this.chart.removeSeries(this.baselineSeries);
          this.baselineSeries = null;
        }
        this.chart.remove();
        this.chart = null;
      }

      // 3. Обновление активного актива
      this.activeSymbol = pair;

      // 4. Загрузка новых данных и создание нового графика
      this.getGraphData(pair.name);
    },
    selectTimeButton(event) {
      let el = event.target.closest(".timeSelectButton");
      let buttons = document.querySelectorAll(".timeSelectButton");
      buttons.forEach((button) => button.classList.remove("active"));
      el.classList.add("active");
      this.selectedTime = el.id.slice(0, 2);
    },
    getGraphData(symbol) {
      console.log("получаем данные для графика", symbol);
      // Убеждаемся, что bot_id есть
      if (!this.botId) {
        const userContext = UserManager.getFullUserContext();
        this.botId = userContext.botId;
        this.$store.commit("setBotId", this.botId);
      }
      fetch(`${window.location.origin}/graphs/${symbol}?user_id=${this.user?.id}&bot_id=${this.botId}`)
        .then((res) => res.json())
        .then((data) => {
          // Конвертируем time в объект Date с учётом временной зоны
          this.graphData = data.map((point) => ({
            time: point.time, // оставляем как есть
            value: point.value,
          }));
          console.log(this.graphData);
          this.initChart();
        })
        .catch((err) => {
          console.error("Ошибка при загрузке графика:", err);
        });
    },
    connectWebSocket(symbol = this.activeSymbol?.name) {
      if (!symbol) {
        console.error("Не указан symbol для WebSocket подключения");
        return;
      }
      const protocol = window.location.protocol === "https:" ? "wss" : "ws";
      this.socket = new WebSocket(`${protocol}:${window.location.host}/ws/graphs`);
      // this.socket = new WebSocket(`ws:localhost:8000/ws/graphs`)

      this.socket.onopen = () => {
        console.log("WebSocket открыт", symbol);
        this.socket.send(
          JSON.stringify({
            type: "subscribe",
            symbol: symbol,
            user_id: this.user?.id,
          })
        );
      };

      this.socket.onmessage = (event) => {
        console.log("[WebSocket] Получено сообщение:", event.data);
        const message = JSON.parse(event.data);
        console.log("[WebSocket] Распарсено сообщение:\nCurrent symbol:", symbol, "\nMessage:", message);

        if (message.symbol === symbol) {
          if (this.baselineSeries) {
            const timestamp = new Date(message.timestamp).getTime();
            let newPoint = {
              time: timestamp,
              value: message.price,
              source: message.source || "api", // Добавляем источник данных
            };

            if (this.baselineSeries && newPoint?.value !== undefined && !isNaN(newPoint.value) && newPoint.time) {
              // Фильтрация по времени и приоритету
              if (this.shouldUpdateChart(newPoint)) {
                console.log("yes go update");
                this.baselineSeries.update(newPoint);
                this.graphData.push(newPoint);
                this.timeFilterGraphData.push(newPoint);
                this.lastPoint = newPoint;
                this.updateChartBaseLine();
              }
            } else {
              console.warn("Неверные данные для графика:", newPoint);
            }
          }
        }
        if (this.resultBet) {
          this.isNotifyShow = false;
          this.showResult();
          this.getBalance();
        }
      };

      this.socket.onclose = () => {
        console.log("WebSocket закрыт");
      };

      this.socket.onerror = (error) => {
        console.error("Ошибка WebSocket", error);
        this.socket.close();
      };
    },
    calculateAveragePrice(data) {
      const sum = data.reduce((acc, point) => acc + point.value, 0);
      return sum / data.length;
    },
    updateChartBaseLine(status) {
      // Фильтруем данные в зависимости от временного промежутка
      status == "init" ? (this.timeFilterGraphData = this.graphData.slice(-720)) : null;

      if (!this.baselineSeries) {
        // Если серии ещё нет — создаём её (только один раз)
        this.baselineSeries = this.chart.addSeries(BaselineSeries, {
          baseValue: { type: "price", price: this.calculateAveragePrice(this.timeFilterGraphData) },
          topFillColor1: "rgba(38, 166, 154, 0.28)",
          topFillColor2: "rgba(38, 166, 154, 0.05)",
          bottomFillColor1: "rgba(239, 83, 80, 0.28)",
          bottomFillColor2: "rgba(239, 83, 80, 0.05)",
          topLineColor: "#16C482",
          bottomLineColor: "#FF5858",
          lineWidth: 2,
          lineColor: "#26a69a",
          priceLineVisible: true,
          lastValueVisible: true,
          lastValueLabel: {
            backgroundColor: "#ffffff",
            borderColor: "#ff0000",
            borderRadius: 8,
            color: "#fff",
            fontSize: 12,
          },
        });
      } else {
        // Обновляем параметры базовой линии
        this.baselineSeries.applyOptions({
          baseValue: { type: "price", price: this.calculateAveragePrice(this.timeFilterGraphData) },
        });
      }

      // Обновляем данные графика
      this.baselineSeries.setData(this.timeFilterGraphData);
    },
    // updateChartBaseLine(status) {
    //   // status != "init" ? this.chart.removeSeries(this.baselineSeries) : null
    //   status == "init" ? (this.timeFilterGraphData = this.graphData.slice(-720)) : null
    //   this.baselineSeries = this.chart.addSeries(BaselineSeries, {
    //     baseValue: { type: "price", price: this.calculateAveragePrice(this.timeFilterGraphData) },
    //     topFillColor1: "rgba(38, 166, 154, 0.28)",
    //     topFillColor2: "rgba(38, 166, 154, 0.05)",
    //     bottomFillColor1: "rgba(239, 83, 80, 0.28)",
    //     bottomFillColor2: "rgba(239, 83, 80, 0.05)",
    //     topLineColor: "#16C482",
    //     bottomLineColor: "#FF5858",
    //     lineWidth: 2,
    //     lineColor: "#26a69a",
    //     priceLineVisible: true,
    //     lastValueVisible: true,
    //     lastValueLabel: {
    //       backgroundColor: "#ffffff",
    //       borderColor: "#ff0000",
    //       borderRadius: 8,
    //       color: "#fff",
    //       fontSize: 12,
    //     },
    //   })
    //   this.baselineSeries.setData(this.timeFilterGraphData)
    //   console.log("Делаю делаю")
    // },

    selectTime(timeFrame, event) {
      let text = event.target;
      text.classList.add("selectedTime");
      this.currentTimeFrame = timeFrame;
      switch (timeFrame) {
        case "1m":
          this.timeFilterGraphData = this.graphData.slice(-5);
          break;
        case "30m":
          this.timeFilterGraphData = this.graphData.slice(-360);
          break;
        case "1h":
          this.timeFilterGraphData = this.graphData.slice(-720);
          break;
      }
      console.log(this.timeFilterGraphData.length);
      this.updateChartBaseLine();
      this.chart.timeScale().fitContent();
    },
    openCurrencies() {
      this.isSelectCurrency = true;
    },
    async selectCurrency(cur) {
      try {
        const response = await axios.post(`${window.location.origin}/user/set_currency/${this.botId}/${this.user.id}?currency=${cur}`);
        console.log(response);
        this.currency.name = cur;
        const [wholePart, fractionalPart] = this.balanceCurrencies[cur].toString().split(".");
        this.balance = parseInt(wholePart) || 0;
        this.balanceCents = (fractionalPart || "00").padEnd(2, "0").substring(0, 2);
        this.updateCurrencySymbol(cur);
        this.isSelectCurrency = false;
        this.$store.commit("setCurrency", cur);
      } catch (err) {
        console.log(err);
      }
      // this.getBalance()
    },
    updateCurrencySymbol(currency) {
      const symbols = {
        RUB: "₽",
        USD: "$",
        UAH: "₴",
        KZT: "₸",
      };
      this.currency.symbol = symbols[currency] || "₽";
    },
    initChart() {
      const theme = document.querySelector("html").getAttribute("data-theme");

      this.chart = createChart(this.$refs.chartContainer, {
        width: this.$refs.chartContainer.clientWidth,
        height: this.$refs.chartContainer.clientHeight,
        layout: {
          background: {
            color: theme === "dark" ? "#2c2c2e" : "#ffffff",
          },
          textColor: theme === "dark" ? "#fff" : "#000000",
        },
        grid: {
          vertLines: { color: theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(199, 199, 204, 1)" },
          horzLines: { color: theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(199, 199, 204, 1)" },
        },
        rightPriceScale: {
          visible: true,
        },
        timeScale: {
          visible: true,
          timeVisible: true,
          secondsVisible: true,
          tickMarkFormatter: (time, tickMarkType, locale) => {
            return this.defaultTickMarkFormatter({ timestamp: time - this.userTimezone }, tickMarkType, locale);
          },
        },
      });

      this.updateChartBaseLine("init");
      console.log(this.baselineSeries, "СИРИИС", this.chart);

      // Инициализируем lastPoint с источником данных
      const lastGraphPoint = this.graphData[this.graphData.length - 1];
      if (lastGraphPoint) {
        this.lastPoint = {
          ...lastGraphPoint,
          source: lastGraphPoint.source || "api", // Добавляем источник по умолчанию
        };
      }

      if (this.activeSymbol && this.activeSymbol.name) {
        this.connectWebSocket(this.activeSymbol.name);
      }
    },
    defaultTickMarkFormatter(timePoint, tickMarkType, locale) {
      const formatOptions = {};

      switch (tickMarkType) {
        case 0: //TickMarkType.Year:
          formatOptions.year = "numeric";
          break;

        case 1: // TickMarkType.Month:
          formatOptions.month = "short";
          break;

        case 2: //TickMarkType.DayOfMonth:
          formatOptions.day = "numeric";
          break;

        case 3: //TickMarkType.Time:
          formatOptions.hour12 = false;
          formatOptions.hour = "2-digit";
          formatOptions.minute = "2-digit";
          break;

        case 4: //TickMarkType.TimeWithSeconds:
          formatOptions.hour12 = false;
          formatOptions.hour = "2-digit";
          formatOptions.minute = "2-digit";
          formatOptions.second = "2-digit";
          break;

        default:
        // ensureNever(tickMarkType);
      }

      const date = timePoint.businessDay === undefined ? new Date(timePoint.timestamp * 1000) : new Date(Date.UTC(timePoint.businessDay.year, timePoint.businessDay.month - 1, timePoint.businessDay.day));

      // from given date we should use only as UTC date or timestamp
      // but to format as locale date we can convert UTC date to local date
      const localDateFromUtc = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());

      return localDateFromUtc.toLocaleString(locale, formatOptions);
    },
    betStart(direction) {
      console.log(this.chart, direction);
      console.log(this.lastPoint);
      // if (this.betAmount < 100) {
      //   this.showError(this.$store.getters.getLanguage == "RU" ? "Ставка не может быть меньше 100 RUB" : "The rate cannot be less than 100 RUB")
      //   return
      // }
      if (this.selectedTime < 1) {
        this.showError(this.$t("betMinOneSecond"));
        return;
      } else if (this.selectedTime > 300) {
        this.showError(this.$t("betMaxFiveMinutes"));
        return;
      }

      if (!this.activeSymbol || !this.activeSymbol.name) {
        this.showError(this.$t("assetNotSelected"));
        return;
      }

      const userContext = UserManager.getFullUserContext();

      axios
        .post(`${window.location.origin}/bet/start`, {
          user_id: userContext.user.id,
          bot_id: this.botId,
          asset: this.activeSymbol.name,
          duration: Number(this.selectedTime),
          bet: Number(this.betAmount),
          direction: direction == "up" ? 1 : -1,
        })
        .then((res) => {
          console.log(res);
          if (res.data.success) {
            this.isNotifyShow = true;
            this.priceLine = this.baselineSeries.createPriceLine({
              price: this.lastPoint.value,
              color: `${direction == "up" ? "#16C482" : "#FF5858"}`,
              lineWidth: 2,
              lineStyle: 0, // Solid
              axisLabelVisible: true,
              title: `${this.betAmount} ${this.currency.symbol} ${direction == "up" ? "↑" : "↓"}`,
            });
            setTimeout(() => {
              this.resultBet = {
                result: res.data.result,
                amount: res.data.amount,
                betAmount: Number(this.betAmount),
              };
            }, Number(this.selectedTime) * 1000 + 1000);
            // setTimeout(() => {
            //   this.baselineSeries.removePriceLine(this.priceLine)
            //   if (res.data.result == "win") {
            //     this.resultMessage = this.$t("winResult")
            //     this.resultStatus = "win"
            //   } else {
            //     this.resultMessage = this.$t("loseResult")
            //     this.resultStatus = "lose"
            //   }
            //   this.isResultShow = true
            // }, Number(this.selectedTime) * 1000 + 1000)
          } else {
            if (res.data.message.includes("Minimum")) {
              const sum = res.data.message.split("is")[1];
              return this.showError(this.$t("minBet", { amount: sum }));
            }
            if (res.data.message.includes("cash_null")) {
              return this.showError(this.$t("cash_null"));
            }

            res.data.message === "Invalid request data" ? this.showError(this.$t("checkData")) : this.showError(translateApiError(this.$t.bind(this), res.data.message));
          }
        })
        .catch((err) => {
          console.log(err);
          this.showError(translateApiError(this.$t.bind(this), err.response?.data?.detail));
        });
    },
    showResult() {
      this.baselineSeries.removePriceLine(this.priceLine);
      if (this.resultBet.result == "win") {
        this.resultMessage = this.$t("winResult");
        this.resultStatus = "win";
      } else {
        this.resultMessage = this.$t("loseResult");
        this.resultBet.amount = this.resultBet.betAmount;
        this.resultStatus = "lose";
      }
      this.isResultShow = true;
      setTimeout(() => {
        this.resultBet = null;
        this.isResultShow = false;
      }, 6000);
    },
    showError(message) {
      this.errorMessage = message;
      this.isErrorShow = true;
    },
    getBalance({ silent = false } = {}) {
      if (!this.user || !this.botId) {
        console.error("Нет данных пользователя для запроса баланса");
        if (!silent) {
          this.isBalanceLoading = false;
        }
        return;
      }

      if (!silent) {
        this.isBalanceLoading = true;
      }

      axios
        .get(`${window.location.origin}/user/balance/${this.botId}/${this.user.id}`)
        .then((res) => {
          if (applyBalanceResponse(res.data, this)) {
            this.$store.commit("setBalanceData", res.data);
          }
          this.isBalanceLoading = false;
        })
        .catch((err) => {
          console.log("БАЛАНС ОШИБКА", err);
          if (!this.balanceCurrencies) {
            this.balance = 0;
            this.balanceCents = "00";
          }
          this.isBalanceLoading = false;
        });
    },
    async fetchActives() {
      console.log(this.$store.getters.getActives);
      this.isLoadingActives = true;
      if (this.$store.getters.getActives.length == 0) {
        const userContext = UserManager.getFullUserContext();

        try {
          const res = await fetch(`${window.location.origin}/actives/user/${userContext.botId}/${userContext.user.id}`);
          const data = await res.json();
          // ИСПРАВИТЬ: обработка новой структуры данных
          if (data.error) {
            console.error("Ошибка загрузки активов:", data.message);
            this.actives = [];
            this.isLoadingActives = false;
            return;
          }

          this.actives = data.actives;
          this.$store.commit("setActives", data.actives);
          this.isLoadingActives = false;
          console.log(this.actives);
        } catch (err) {
          console.error("Ошибка при загрузке активов:", err);
          this.actives = [];
          this.isLoadingActives = false;
        }
      } else {
        this.actives = this.$store.getters.getActives;
        this.isLoadingActives = false;
      }
    },
    initializeUser() {
      // Получаем данные пользователя из store или инициализируем заново
      const storedUser = this.$store.getters.getTgUserData;
      const storedBotId = this.$store.getters.getBotId;

      if (storedUser && storedBotId) {
        this.user = storedUser;
        this.botId = storedBotId;
        console.log("Данные пользователя из store:", this.user, this.botId);
      } else {
        const userContext = UserManager.getFullUserContext();
        this.user = userContext.user;
        this.botId = userContext.botId;
        this.$store.commit("setTgUserData", this.user);
        this.$store.commit("setBotId", this.botId);
        console.log("Новые данные пользователя:", this.user, this.botId);
      }
    },
    async checkBotType() {
      if (!this.botId) {
        console.error("botId не установлен для проверки типа бота");
        return;
      }
      try {
        const response = await axios.get(`${window.location.origin}/tech/bot_type/${this.botId}`);
        if (response.data && response.data.success) {
          this.isTradeShare = response.data.is_trade_share || false;
          console.log("Тип бота:", this.isTradeShare ? "TRADE SHARE" : "TRADE");
        }
      } catch (err) {
        console.error("Ошибка при проверке типа бота:", err);
        this.isTradeShare = false;
      }
    },
    shouldUpdateChart(newPoint) {
      console.log("Проверяем на обновление графика:", newPoint);

      const MIN_INTERVAL = 5; // 5 секунд в миллисекундах
      const SOURCE_PRIORITY = {
        simulation: 3,
        api: 2,
        noise: 1,
      };

      // Если это первая точка
      if (!this.lastPoint) {
        console.log("first point");
        return true;
      }

      const timeDiff = newPoint.time - this.lastPoint.time;

      console.log("timeDiff", timeDiff);

      // Если прошло достаточно времени - принимаем новую точку
      if (timeDiff >= MIN_INTERVAL) {
        console.log("time diff");
        return true;
      }

      // Если времени прошло мало, проверяем приоритет
      const newPriority = SOURCE_PRIORITY[newPoint.source] || 1;
      const lastPriority = SOURCE_PRIORITY[this.lastPoint.source] || 1;

      console.log("newPriority", newPriority, "lastPriority", lastPriority);

      // Принимаем только если новая точка имеет более высокий приоритет
      if (newPriority >= lastPriority) {
        return true;
      }

      // Если приоритеты равны и времени прошло мало - не обновляем
      console.log("else");
      return false;
    },
  },
  async mounted() {
    // Инициализируем пользователя
    this.initializeUser();
    this.userTimezone = new Date().getTimezoneOffset() * 60;
    console.log("таймзон", this.userTimezone);
    
    // Проверяем тип бота
    if (this.botId) {
      await this.checkBotType();
    }
    
    // Загружаем активы перед инициализацией символа
    if (this.user && this.botId) {
      await this.fetchActives();
    }
    
    // Инициализируем символ только после загрузки активов
    let btc = {
      name: "Bitcoin",
      symbol: "BTC",
      img: "https://xapiimagehandler.pro/files/9gjZaHuG5yTx.png",
      usd_value: 93730.9,
      amount: 0,
      fiat_value: 0,
      changePercent: -0.74,
    };
    let cur = this.$store.getters.getTradeSymbol != undefined ? this.$store.getters.getTradeSymbol : btc;
    console.log("КУР", cur);
    // Устанавливаем activeSymbol только если есть данные
    if (cur && cur.name) {
      this.activeSymbol = cur;
      switch (this.$store.getters.getCurrency) {
        case "RUB":
          this.currency.symbol = "₽";
          break;
        case "USD":
          this.currency.symbol = "$";
          break;
        case "UAH":
          this.currency.symbol = "₴";
          break;
        case "KZT":
          this.currency.symbol = "₸";
          break;
      }
      this.getGraphData(cur.name);
    }

    // Загружаем данные пользователя
    if (this.user && this.botId) {
      const cachedBalance = this.$store.getters.getBalanceData;
      if (cachedBalance && applyBalanceResponse(cachedBalance, this)) {
        this.isBalanceLoading = false;
        this.getBalance({ silent: true });
      } else {
        this.getBalance();
      }
    }

    // Удаляем логотип TradingView
    const logo = document.querySelector("#tv-attr-logo");
    if (logo) {
      console.log("ЛОГОООО", logo);
      logo.remove();
    }
  },
  beforeUnmount() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log("Закрываем WebSocket перед уничтожением компонента");
      this.socket.close(1000, "Component unmounted");
    }
  },
};
</script>

<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  background-color: var(--background-color);
  height: 100vh;
  max-width: 100vw;
  overflow-y: hidden;
}
.balanceBlock {
  display: flex;
  justify-content: space-between;
}
.pairBlock {
  background-color: var(--second-color);
  border-radius: 10px;
  text-align: left;
  display: flex;
  align-items: center;
  height: 60px;
  padding: 5px;
  position: relative;
  cursor: pointer;
}
.pairBlock p {
  font-size: 17px;
}
.selectPairBlock {
  position: absolute;
  top: 110%;
  right: 0;
  width: 100%;
  background: var(--button-background);
  border-radius: 10px;
  z-index: 5;
  filter: drop-shadow(0 0 5px var(--background-color));
  padding: 5px;
}
.activesList {
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow-y: scroll;
  max-height: 50vh;
}
.activeBlock {
  background-color: var(--background-color);
  padding: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
}
.images {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 13%;
  height: 100%;
  margin-right: 5px;
}
.images img {
  width: 25px;
}
#firstImage {
  position: absolute;
  left: 10%;
  transform: translateY(70%);
  z-index: 2;
}
#secondImage {
  position: absolute;
  right: 10%;
  transform: translateY(30%);
  z-index: 1;
}
.cashBlock {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.cashText {
  color: var(--black-to-white);
  font-size: 26px;
  font-family: "SF Compact Rounded";
  font-weight: 600;
}
.cashText span {
  color: var(--text-color2);
  font-family: "SF Compact Rounded";
}
.depositButton {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: var(--deposit-color);
  border: 0;
  border-radius: 10px;
  height: 85%;
  padding-left: 25px;
  padding-right: 25px;
  cursor: pointer;
}
.timeClick {
  display: flex;
  gap: 15px;
  color: var(--black-to-white);
  margin-bottom: 10px;
}
.timeClick p {
  opacity: 0.4;
  cursor: pointer;
}
.tradingBlock {
  display: flex;
  flex-direction: column;
  height: 55%;
}
.chartBlock {
  flex-grow: 1;
  padding: 10px; /* Внешний отступ */
  padding-bottom: 0;
  background: var(--second-color);
  border-radius: 10px;
  overflow: hidden;
}
.controlBlock {
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 3vh;
  width: 93%;
  left: 50%;
  transform: translateX(-50%);
  gap: 10px;
}
.inputBlock {
  display: flex;
  justify-content: space-between;
  background-color: var(--button-background);
  font-size: 17px;
  padding: 5px;
  border-radius: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.verticalHr {
  border: 0.2px solid var(--hr-color);
}
.inputBlock input {
  width: 100%;
  background-color: transparent;
  border: 0;
  text-align: center;
  color: var(--text-color1);
  font-size: 17px;
  outline: none;
  padding: 10px;
}
.inputText {
  display: flex;
  gap: 5px;
}
.inputText p {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.downButton,
.upButton,
.timeButton {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  border-radius: 10px;
  color: white;
  padding: 10px;
  cursor: pointer;
}
.downButton,
.upButton {
  width: 100%;
}
.downButton p,
.upButton p {
  font-family: "SF Pro Text Bold";
  font-size: 16px;
}
.buttonsBlock {
  display: flex;
  width: 100%;
  gap: 10px;
}
.downButton {
  background-color: #ff5858;
}
.timeButton {
  background-color: #e0e1e6;
}
.upButton {
  background-color: #16c482;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Убираем стрелочки в Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.timeBlock {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--background-color);
  overflow-y: hidden;
  padding: 15px;
  border-radius: 10px 10px 0 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.timeHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.timeSelectButtons {
  display: flex;
  width: 100%;
  gap: 10px;
}
.timeSelectButton {
  background-color: var(--button-background);
  border-radius: 10px;
  padding: 13px;
  width: 100%;
  cursor: pointer;
}
.timeSelectButton.active {
  background-color: var(--deposit-color);
  transition: all 0.3s;
  color: white;
}
.timeInput {
  width: 100%;
  background-color: var(--button-background);
  border-radius: 10px;
  border: 0;
  padding: 13px;
  font-size: 17px;
  outline: none;
  color: var(--text-color1);
}
.timeAcceptButton {
  background-color: #007aff;
  border-radius: 10px;
  padding: 15px;
  color: var(--button-text-color);
  border: 0;
  font-size: 16px;
  font-family: "SF Pro Text Bold";
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s;
}
.timeAcceptButton.active {
  opacity: 1;
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.18s ease-in-out;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}
.slide-up-enter-to,
.slide-up-leave-from {
  transform: translateY(0);
}

.home::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5); /* Затемнение */
  z-index: 10;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.home.time-active::before {
  opacity: 1;
  pointer-events: auto; /* Блокирует клики по затемненной области */
}
.selectCurrencies {
  position: absolute;
  top: 110%;
  right: 0;
  background-color: color-mix(in srgb, var(--second-color) 70%, transparent);
  border-radius: 15px;
  width: 25vw;
  z-index: 5;
  text-align: center;
  padding: 5px 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border: 1px solid rgba(255, 255, 255, 0.287);
  backdrop-filter: blur(5px);
}
.selectCurrencies p {
  padding: 5px;
  background-color: var(--background-color);
  border-radius: 15px;
  cursor: pointer;
}
.selectedCurrency {
  color: #007aff;
}
.selectedTime {
  opacity: 1 !important;
}
</style>
